import React from "react";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";


const NumberedBulletItem = ({ number, text }) => {
  return (
    <div className="flex flex-row gap-4 font-bold items-center px-6">
      <div className="">{number}.</div>
      <div className="font-normal">{text}</div>
    </div>
  )
}

const ContentTermsAndConditions = () => {
  const LAST_UPDATED = "March 26, 2025";

  return (
    <div className="flex flex-col gap-8">
      <h1 className="font-bold text-4xl">Terms and Conditions</h1>

      <p className="text-color-dark-text-secondary">
        Last updated: {LAST_UPDATED}
      </p>

      <RaindropCard>
        <div className="flex flex-col gap-4 text-left">
          <h2 className="font-bold text-3xl">
            Someone finally wants to read the Terms!  Thank you 🥳
          </h2>
          <p className="text-color-dark-text-secondary">
            To make it easier, we've distilled the most important bits into
            plain english here. You can read the full legalese below.
          </p>
          <NumberedBulletItem
            number={1}
            text="You're okay with us taking money from you."
          />
          <NumberedBulletItem
            number={2}
            text="You're okay with us combining your money with others to make a single donation."
          />
          <NumberedBulletItem
            number={3}
            text="You're okay with us changing your distributions on your behalf to account if an organisation leaves the platform"
          />

        </div>
      </RaindropCard>

      <h2 className={"font-bold text-2xl"}>1. Acceptance of Terms</h2>
      <p>
        By using The Raindrop Company services, you agree to these terms and
        conditions. If you disagree with any parts, please do not use our
        service.
      </p>

      <h2 className={"font-bold text-2xl"}>2. Services Description</h2>
      <p>
        The Raindrop Company services is a social media platform designed to let
        users donate to charities and create content to encourage their network
        to also donate.
      </p>

      <h2 className={"font-bold text-2xl"}>3. User Conduct</h2>
      <p>
        Each user is responsible for any content they post. Users may not post
        any illegal or harmful content. Harassment, discrimination, or any form
        of harmful behavior is strictly prohibited.
      </p>

      <h2 className={"font-bold text-2xl"}>4. Donation Process</h2>
      <p>
        Users can choose to donate to selected charities available in the app.
        The Raindrop Company services is not responsible for the internal
        operations of these charities, but we endeavour to partner with
        reputable charities.
      </p>

      <h2 className={"font-bold text-2xl"}>5. Privacy Policy</h2>
      <p>
        The Raindrop Company services respects the privacy of its users. Any
        information we collect through this service will be handled according to
        our Privacy Policy.
      </p>

      <h2 className={"font-bold text-2xl"}>6. Changes to These Terms</h2>
      <p>
        We may revise these terms from time to time. We will notify users of any
        changes and their continued use of The Raindrop Company services will
        indicate acceptance of these changes.
      </p>

      <h2 className={"font-bold text-2xl"}>7. Termination</h2>
      <p>
        The Raindrop Company services has the right to terminate any user
        account for violation of these terms.
      </p>

      <h2 className={"font-bold text-2xl"}>8. Liability</h2>
      <p>
        Under no circumstances shall The Raindrop Company services be liable for
        any direct or indirect damages arising out of the use of our service.
      </p>

      <h2 className={"font-bold text-2xl"}>9. Governing Law</h2>
      <p>These terms shall be governed by the laws of the United Kingdom.</p>

      <h2 className={"font-bold text-2xl"}>10. Contact Us</h2>
      <p>
        If you have any concerns or questions about these terms, please contact
        us at support@theraindropcompany.com.
      </p>
    </div>
  );
};

const StratusTermsAndConditions = () => {
  return (
    <div
      id={"page--about-us"}
      className="flex flex-col w-full py-12 justify-center items-center "
    >
      <div className="flex flex-col w-full gap-6  ">
        <ContentTermsAndConditions />
      </div>
    </div>
  );
};

export default StratusTermsAndConditions;
